// removed by extract-text-webpack-plugin
module.exports = {"Card":"Ar40LOeH-lv2kDZIPj3Mn","Title":"_39euhpC9GOMmHB8wX37Tio","Row":"s2yYexNqHFOQVm3Eko4--","RowLabel":"_3g8kQLTJXEpwMhH8Qn_zwb","RowValue":"sBHZGz256hzdEXoQTsyAv","MethodBody":"h9tAvg8EQRxU2DVc1yFgo","MethodAmount":"_25cbOeETANnAuylEs-Z4wp","MethodFee":"_19wLMPVvD-oopue-8CZLpV","Disclaimer":"_3rKfZfuL6eKAlKZEXCcahd","CrossLinkBlock":"_38zC6UfgVcthpPhpW29HWu","CrossLinkHint":"_1ZoEGuRCrAo0pyMmx1qP7o","CrossLink":"nL1wCx-qAosTDIMVhk_Zd","WrongType":"_19WEYfAjfedNyJ1EgW6rW0","WrongTypeText":"_1GGkI0oQ4flGqpg6eOv_Nw"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryInfoCard/styles.module.css
// module id = 573
// module chunks = 0